var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 13.1667L9.99984 16.5M9.99984 16.5L13.3332 13.1667M9.99984 16.5V9M16.6665 12.9524C17.6844 12.1117 18.3332 10.8399 18.3332 9.41667C18.3332 6.88536 16.2811 4.83333 13.7498 4.83333C13.5677 4.83333 13.3974 4.73833 13.3049 4.58145C12.2182 2.73736 10.2119 1.5 7.9165 1.5C4.46472 1.5 1.6665 4.29822 1.6665 7.75C1.6665 9.47175 2.36271 11.0309 3.48896 12.1613",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/Icon (3).ec9bf3674ae8cb6a90196eec145907d7.svg";
export { ForwardRef as ReactComponent };